/* eslint-disable @typescript-eslint/no-explicit-any */
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Trans, useTranslation } from "react-i18next";
import { Card } from "primereact/card";
import {
    useContext,
    useEffect,
    useRef,
    useState,
    MutableRefObject
} from "react";
import { PaymentContext } from "./PaymentContext";
import { GetDomainFromEmail } from "../../helpers/emails";
import { checkPaidAccess } from "../../services/TokenService";
import { useLocation } from "react-router-dom";
import { setAccessTokenCookie } from "../../helpers/cookieCreator";
import { Loading } from "../loading/Loading";

/**
 * Card payment success page
 * @returns
 */
export const CardPaymentSuccess = () => {
    const { t } = useTranslation("locale");
    const paymentContext = useContext(PaymentContext);
    const location = useLocation();

    const [loading, setLoading] = useState(false);

    const invoiceEmail = paymentContext.data.invoiceDetails.email ?? "";
    const inspectionId = paymentContext.data.resaleCostDetails.inspectionId;
    const email = location.state.email;

    const domain = GetDomainFromEmail(email);

    const tokenRef: MutableRefObject<string | null> = useRef(null);

    useEffect(() => {
        const fetchToken = async () => {
            setLoading(true);
            const data = await checkPaidAccess(inspectionId, email);
            tokenRef.current = data;
            setAccessTokenCookie(
                JSON.stringify({
                    paid: true
                }),
                inspectionId
            );
            setLoading(false);
        };
        if (email) {
            fetchToken();
        }
    }, []);

    if (loading) {
        return <Loading />
    }

    return (
        <Card title={t("payments.payment_success.card_title")}>
            <div>
                <p>
                    {t("payments.payment_success.card_info")} {invoiceEmail}.
                </p>

                <p className="mt-4">
                    {t("payments.payment_success.queries")}
                </p>

                <p className="mt-4">
                <Trans i18nKey="payments.payment_success.contact_us" t={t}>
                        <a 
                            data-cy="contact_btn"
                            className="contactUsText"
                            href="https://www.idwalmarine.com/contact-us"
                            target="_blank"
                        >
                        </a>
                    </Trans>
                </p>

                <h3 className="mt-4 pb-2">
                    {t("payments.payment_success.organisation_access_title")}
                </h3>

                <div className="mt-1 gap-3 flex align-items-center">
                    <p>
                        <Trans i18nKey="payments.payment_success.organisation_share_info">
                            Once the report has generated, your colleagues on the email domain @{{ domain }} will be able to register for access to the Idwal platform to view the report.
                        </Trans>
                    </p>
                </div>
            </div>
        </Card>
    );
};
